export class Pixel {
  private r: number;
  private g: number;
  private b: number;
  private a: number;

  constructor(r: number, g: number, b: number, a?: number) {
    this.r = r;
    this.g = g;
    this.b = g;
    this.a = typeof a === "undefined" ? 255 : a;
  }

  getDarkness() {
    if (this.a === 0) {
      return 0;
    }
    return 1 - (0.299 * this.r + 0.587 * this.g + 0.114 * this.b) / 255;
  }

  toString() {
    return this.r + "," + this.g + "," + this.b + "," + this.a;
  }
}
